// Omnix/common/schemas/collections/omniOtpRequests.js
import { z } from "zod";

const OmniOtpRequestSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this request belongs to."),
    
    otpRequestId: z.string().uuid().describe("The unique, public-facing ID for this request."),
    contactId: z.string().optional().nullable().describe("The contactId if the contact already exists."),
    
    codeHash: z.string().describe("The securely hashed OTP code."),
    
    status: z.enum(['pending', 'verified', 'expired', 'failed']).default('pending'),
    expiresAt: z.coerce.date().describe("The timestamp when this OTP code expires."),
    
    attempts: z.number().int().default(0).describe("Number of verification attempts made."),
    
    createdAt: z.coerce.date().optional(),
});

export default OmniOtpRequestSchema;